"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJsonFromUrl = exports.isTest = exports.isLZWKAPP = void 0;
function isLZWKAPP() {
    return /lycheer/.test(navigator.userAgent.toLocaleLowerCase());
}
exports.isLZWKAPP = isLZWKAPP;
function isTest() {
    return /(dbg.lizhiweike.com)|(localhost)/.test(window.location.host);
}
exports.isTest = isTest;
function getJsonFromUrl() {
    var query = location.search.substr(1);
    var result = {};
    query.split("&").forEach(function (part) {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}
exports.getJsonFromUrl = getJsonFromUrl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/operation-report/dist/utils/tools.js
// module id = 208
// module chunks = 0